import React from '../../../_snowpack/pkg/react.js';
import PropTypes from '../../../_snowpack/pkg/prop-types.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
import { colors } from '../index.js';
const StyledRow = styled.div.withConfig({
  displayName: "table-row__StyledRow",
  componentId: "sc-1gmvb6s-0"
})(["display:grid;grid-auto-flow:column dense;grid-auto-columns:minmax(100px,1fr);justify-content:space-between;padding:0 0.5rem;border-top:", ";color:", ";font-size:", ";grid-column-gap:0.5rem;", " ", " ", " grid-template-columns:", ";:hover{background-color:", ";}"], ({
  header
}) => header ? 'none' : '1px solid #dfdfdf', props => props.header ? colors.frostbite : colors.frostbite, props => props.header ? '14px' : 'inherit', ({
  align
}) => align === 'bottom' && 'align-items: flex-end;', ({
  align
}) => align === 'top' && 'align-items: flex-start;', ({
  align
}) => align === 'center' && 'align-items: center;', ({
  gridTemplateColumns
}) => gridTemplateColumns && gridTemplateColumns, props => props.hover ? colors.grey : 'transparent');
const ExpandableWrapper = styled.div.withConfig({
  displayName: "table-row__ExpandableWrapper",
  componentId: "sc-1gmvb6s-1"
})(["height:100%;padding:1rem 0.5rem;display:flex;flex-wrap:wrap;"]);
export const TableRow = ({
  align,
  children,
  expand,
  expandContent: ExpandContent,
  gridTemplateColumns,
  header,
  hover
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledRow, {
    align: align,
    gridTemplateColumns: gridTemplateColumns,
    header: header,
    hover: hover
  }, children), expand && /*#__PURE__*/React.createElement(ExpandableWrapper, null, /*#__PURE__*/React.createElement(ExpandContent, null)));
};
TableRow.defaultProps = {
  align: 'center',
  gridTemplateColumns: '1fr'
};
TableRow.propTypes = {
  align: PropTypes.oneOf(['top', 'center', 'bottom']),
  expand: PropTypes.bool,
  expandContent: PropTypes.elementType,
  gridTemplateColumns: PropTypes.string,
  header: PropTypes.bool,
  hover: PropTypes.bool
};